import { type ImportSourceType } from '~/utils/ImportUtils';

export const IMPORT_SOURCES: ImportSourceType[] = ['dropbox', 'box', 'googleDrive'];

export const INTERNAL_IMPORT_SOURCES: ImportSourceType[] = ['brandfolder', 'canto', 'sharePoint', 'frameio'];
